import WoayClient from './main';
import $ from 'cash-dom';


function WoayCore(Options, game, eventBus, soundObj) {
    const client = new WoayClient(Options, eventBus, soundObj);
    const {
        html,
        reward,
        auth,
        helper,
        sound,
        api,
        local,
        quiz
    } = client;

    const {
        Wheel,
        SETTINGS
    } = Options;
    let clicked = false;
    let isEnoughPointReward = false;
    let quickScheme = Options.Wheel.scheme;
    let pointReward = 0;
    let startGameCaoThe = false;
    let isSpinning = false;
    let list_user = [];
    const verifyLoginDone = client.verifyLoginDone.bind(client);
    const updateInfoAfterLogin = client.updateInfoAfterLogin.bind(client);
    const loginMethod = Options.Wheel.login_method;
    html.injectHtml(Options);
    html.add3rdPartyLib();
    auth.checkLoginWithManychat(verifyLoginDone);
    auth.checkAuthParam(verifyLoginDone);
    if (loginMethod === 'haravan_order') {
        auth.checkLoginWithHaravan();
    }
    if (loginMethod === 'sapo_order') {
        auth.checkLoginWithSapo();
    }

    if (eventBus) {
        handleEvents();
    }
    if (Wheel.game_type == 'lucky_draw') {
        api.http.setToken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTAwMDEwNSwibmFtZSI6IlbDsm5nIFRo4bq_IEFuIiwicGhvbmUiOiIrODQ5MDEzNDQ4NjMiLCJlbWFpbCI6InZvbmd0aGVhbi53b2F5QGdtYWlsLmNvbSIsImFkZHJlc3MiOm51bGwsImlkZW50aXR5IjpudWxsLCJwcm92aWRlcl91aWQiOiJ2b25ndGhlYW4ud29heUBnbWFpbC5jb20iLCJwcm92aWRlcl90eXBlIjoiZW1haWwiLCJ0eXBlIjoic3VwZXJfYWRtaW4iLCJyb2xlIjoic3VwZXJfYWRtaW4iLCJyb2xlcyI6WyJzdXBlcl9hZG1pbiJdLCJhdmF0YXIiOm51bGwsInRyaWFsX2V4cGlyZWRfYXQiOiIyMDIyLTA4LTE2VDEwOjM0OjIyLjA5NloiLCJpc19wcmVtaXVtIjp0cnVlLCJpc190cmlhbCI6ZmFsc2UsImlzX2ZyZWUiOmZhbHNlLCJsZXZlbCI6IlBSTyIsInJlZl9jb2RlIjpudWxsLCJpc19hZmZpbGlhdG9yIjpmYWxzZSwiY29tbWlzc2lvbl9yYXRlIjowLCJzdWJzY3JpcHRpb25fZW5kIjoiMjAyMi0wOC0xNlQxMDozNDoyMi4wOTZaIiwiY3JlYXRlZF9hdCI6IjIwMjItMDgtMDJUMTA6MzQ6MDUuNDcyWiIsImlhdCI6MTY2NTA1MjM0MywiZXhwIjoxNjY1NjU3MTQzfQ.Pp2B3PT5vS74NQ7gmy4lXnd6tOe6yI__ZuQMfZ9pXlE");
    }

    async function start() {
        console.log('woay start');
        const userInfo = client.getUserInfo();
        let turnId = 0;
        // Kiểm tra login
        if (!reward.hasLogin) {
            console.log('not login yet');
            return client.auth.loginHandler(Wheel);
        }

        if (!auth.isUserEnoughData(userInfo)) {
            console.log('show modal woay userinfooooooooooooooooooooooooooooooooooo');
            return html.pushModal('modal-woay-userinfo', 'in core js 4888888');
        }

        if (!reward.isAwading()) {
            startErrorHandler();
        }

        if (isOutOfTurn()) return;

        let turn = reward.getRemainTurnCount();
        //claim nếu còn lượt chơi
        if (turn) {
            await reward.claimReward();
            const currentReward = reward.getCurrentReward();
            turnId = currentReward && currentReward.turn_id;
            console.log('turnId', turnId);
            reward.updateTurnCount();
        }

        isSpinning = true;

        if (Wheel.game_type == 'icon_drop') {
            eventBus.emit('canJump')
            return game.theGame.startPlayGame();
        }

        if (Wheel.game_type == 'flipcard' || Wheel.game_type == 'matching') {
            console.log('OK - Lets go');
            return game.theGame.scene.play.startGame();
        }

        if (Wheel.game_type == 'merge_game') {
            game.theGame.scene.play.startGame();
            game.theGame.scene.play.resetGame();
        }

        if (Wheel.game_type == 'li_xi' || Wheel.game_type == 'flying_gift') {
            sound.stopEffect('background_audio');
            var currentReward = reward.currentReward;
            return game.rollToSku(currentReward.sku);
        }

        if (Wheel.game_type == 'scratching') {
            startGameCaoThe = true;

            if (startGameCaoThe) {
                await reward.award();
                var r = reward.currentReward;
                var the_cao = game.Scratch();

                // the_cao.loadImage(r.sku);
                the_cao.loadText('<b>' + r.name + '</b>');
                the_cao.onFinish(game.thongBaoCaoXong);
                return the_cao
            }
            return
        }

        if (Wheel.game_type == 'crane_game') {
            var currentReward = reward.currentReward;
            return reward.award()
                .then(function () {
                    // html.closeAllModal();
                    const rewardIndex = game.getRewardIndex(currentReward, Options);
                    // console.log('rewardIndex', rewardIndex);
                    game.craneButtonClickChange(rewardIndex);
                })
        }


        if (Wheel.game_type == 'matching_items') {
            var currentReward = reward.currentReward;
            if (reward.hasLogin) {
                return game.gameStart();
            }
        }

        if (Wheel.game_type == 'wheel') {
            if (game.theWheel.isSpinning()) return;
            console.log('isSpinning', isSpinning);
            sound && sound.playEffect("rolling_audio");
            return reward.award(theReward => {
                game.theWheel.rollToSku(theReward.sku);
                isSpinning = false;
                console.log('after isSpinning: ', isSpinning);
            });
        }
        if (Wheel.game_type == 'slot_machine') {
            console.log('go there', isSpinning);
            sound && sound.playEffect("rolling_audio");
            return reward.award(theReward => {
                console.log('theReward', theReward);
                var arr = game.rewardToRollArr(theReward.sku);
                console.log('slot_machine', arr);
                game.theGame.MainScene.startPlay(
                    game.mapToIndex(arr)
                );
            });
        }
        if (Wheel.game_type == 'multiple_choice') {
            game.theGame.startGame(turnId);
        }
    }



    function onVisibilityChanged() {
        if (document.hidden || document.mozHidden || document.webkitHidden || document.msHidden) {
            sound.pauseAll();
        } else {
            sound.playBackground();
        }
    }

    function isOutOfTurn() {
        if (reward.isOutOfTurn()) {
            console.log('het luot');
            html.getModalOutOfTurn(Options, SETTINGS);
            eventBus.emit('outOfTurn');
            return true;
        }
        return false;
    }

    function startErrorHandler() {
        if (reward.error = 'IS_AWARDING') {
            vanillaToast.warning('Vui lòng đợi api awarding', {
                duration: 2000,
                fadeDuration: 200
            })
        }
    }

    // Handle login buttons
    auth.handleLoginButtons(verifyLoginDone, updateInfoAfterLogin);

    //MAIN LOGIC

    $(document).on('click', '.btn-check-reward', function () {
        if (Wheel.game_type == 'wheel' && game.checkSpinning()) return;
        if (Wheel.game_type == 'li_xi' && game.isPicking()) return;
        html.closeAllModal();
        reward.checkRewardList();
    });

    // $('.btn-woay, .bigButton, .btn-play')
    //     .off('click')
    //     .on('click', function () {
    //         sound.playEffect('button_click_audio');
    //         if (Wheel.game_type == 'wheel' && game.checkSpinning()) return;
    //         if (Wheel.game_type == 'li_xi' && game.isPicking()) return;
    //         start();
    //     });


    $(document).on('click', '.btn-submit', function (e) {
        console.log('Wheel.game_type Wheel.game_type Wheel.game_type ', Wheel.game_type);
        if (Wheel.game_type == 'matching_items') {
            game.fnSubmit();
        }
    })

    $(document).off('click', '.btn-woay, .bigButton, .btn-play')
    $(document).on('click', '.btn-woay, .bigButton, .btn-play, #woay-game-btn', function (event) {
        if (!event.detail || event.detail == 1) {
            console.log('button clicked');
            sound.playEffect('button_click_audio');
            const LIST_NOT_USE_SPIN = ['multiple_choice', 'merge_game', 'matching_items'];
            if (!LIST_NOT_USE_SPIN.includes(Wheel.game_type) && isSpinning) return;
            if (Wheel.game_type == 'wheel' && game.checkSpinning()) return;
            if (Wheel.game_type == 'li_xi' && game.isPicking()) return;
            if (Wheel.game_type == 'scratching' && startGameCaoThe) return;
            start();
        }
    })
    $(document).on("click", "#w-confirm-cancel-btn", function () {
        html.closeAllModal();
    });



    $(document).on('click', '#w-confirm-submit-btn', function () {
        console.log('on click btn submit');
        reward.award()
            .then(function () {
                html.closeAllModal();
                const rewardIndex = game.getRewardIndex(reward.currentReward, Options);
                console.log('rewardIndex', reward.currentReward);
                game.activeCurrentCard(rewardIndex);
            })
    })

    //FLOW GAME FLIPCARD + MATCHING

    async function sendPoint(score, r, timeEnd, question_per_day, rightAnswer, totalAnswer) {
        try {
            const totalTime = Wheel.game_type == 'multiple_choice' ? Wheel.rules.question_time_limit : Wheel.rules.TIME;
            // console.log('totalTime', totalTime);
            let timePlay = totalTime - timeEnd;
            if (Wheel.game_type == 'multiple_choice') {
                timePlay = (totalTime * question_per_day) - timeEnd;
            }
            // console.log('timePlay1', timePlay);
            timePlay = Math.min(1000, timePlay);
            timePlay = Math.max(0, timePlay);
            // console.log('timePlay2', timePlay);
            // console.log('rewardId', r.reward_id);
            const payload = {
                reward_id: r.reward_id,
                point: score,
            }
            if (Number.isInteger(timePlay)) {
                Object.assign(payload, {
                    played_time: timePlay
                })
            }
            console.log('payload', payload);
            await api.createPoint(payload)
                .then(function (resp) {
                    console.log('create success', {
                        resp: resp
                    });
                })
            if (Wheel.game_type == 'multiple_choice') {
                html.getQuizModal(Options, SETTINGS, score, rightAnswer, totalAnswer, isEnoughPointReward);
            } else {
                html.getPointsModal(Options, SETTINGS, score, isEnoughPointReward);
            }
            $('.btn-play').css('pointer-events', 'unset');
            if (Wheel.game_type == 'flipcard' || Wheel.game_type == 'matching' || Wheel.game_type == 'merge_game') {
                game.theGame.scene.play.resetGame();
            }
            if (Wheel.game_type == 'crane_game') {
                console.log('resetGame');
            }
            if (Wheel.game_type == 'icon_drop') {
                setTimeout(function () {
                    game.theGame.pause();
                }, 50)
            }
            sound && sound.playEffect('complete_stage_audio');
        } catch (e) {
            client.checkError(e);
        }
    }


    $(document).on('click', '#w-submit-award', function () {
        html.closeAllModal();
        var r = reward.currentReward;
        if (r.code || r.sku == "BADLUCK") {
            reward.updateTurnCount();
            return reward.congratulate(r.sku !== "BADLUCK", Options.is_popup);
        }
    })

    $(document).on('click', '#w-play-again', function () {
        html.closeAllModal();
        start();
    })

    // FLOW ICONDROP

    var viewStacks = [];
    var currentView = '';


    function jumpToView(name) {
        currentView = name;
        viewStacks.push(name);
        $('section, .screen').removeClass('active')
        $('#' + name).addClass('active');
    }

    function jumpBack() {
        viewStacks.pop();
        var view = viewStacks.pop();
        if (!view) {
            view = 'section-main-screen';
        }
        jumpToView(view);
    }


    function handleEvents() {
        eventBus.on('initGame', async function () {
            try {
                var list_prize = await api.fetchPrize();
                list_user = await api.fetchUsers();
                var maxLen = Math.max(...list_user.map((x) => x.player.provider_uid.length));
            } catch (error) {
                console.log('error', error);
            }
            game.theWheel.initPrize(list_prize);
            game.theWheel.setupLength(maxLen || 6);
        })
        eventBus.on('gameOver', async function (score, timeEnd) {
            console.log('game over now');
            await reward.award();
            var r = reward.currentReward;
            console.log('score', score);
            sendPoint(score, r, timeEnd);
        })

        eventBus.on('canJump', function () {
            jumpToView('section-game')
        })

        eventBus.on('exitGame', async function (score, timeEnd) {
            jumpToView('section-main-screen');
            setTimeout(function () {
                game.theGame.pause();
            }, 50)
            console.log('exitGame -> mất lượt');
            await reward.award();
            var r = reward.currentReward;
            sendPoint(score, r, timeEnd);
        })

        eventBus.on('endGame', async function (score, timeEnd) {
            console.log('đã chơi xong game', score);
            var r = reward.currentReward;
            if (quickScheme == 'quick') {
                console.log('scheme là quick');
                pointReward = Options.Wheel.design.POINT_REWARD || Options.Wheel.rules.POINT_REWARD;
                if (!pointReward) {
                    console.log('set mặc định pointReward');
                    pointReward = 0;
                }
                console.log('pointReward', pointReward);
                if (score >= pointReward) {
                    console.log('case trúng quà');
                    isEnoughPointReward = true;
                    await reward.award();
                } else if (score < pointReward) {
                    await reward.cancelAward();
                }
            } else {
                await reward.award();
            }
            sendPoint(score, r, timeEnd);
        })

        eventBus.on('start', function () {
            console.log('call start event');
            start();
        })
        eventBus.on('click-card', function () {
            sound && sound.playEffect('pick_card_audio');
        })
        eventBus.on('fail-card', function () {
            sound && sound.playEffect('fail_card_audio');
        })
        eventBus.on('same-card', function () {
            console.log('play music');
            sound && sound.playEffect('same_card_audio');
        })

        eventBus.on('cancel-award', async function (score, timeEnd) {
            console.log('đã chơi xong game', score);
            var r = reward.currentReward;
            if (quickScheme == 'quick') {
                pointReward = Wheel.rules.POINT_REWARD || Wheel.design.POINT_REWARD;
                console.log('scheme là quick');
                if (!pointReward) {
                    console.log('set mặc định pointReward');
                    pointReward = 0;
                }
                console.log('pointReward', pointReward);
                if (score >= pointReward) {
                    console.log('case trúng quà');
                    isEnoughPointReward = true;
                    await reward.award();
                } else if (score < pointReward) {
                    await reward.cancelAward();
                }
            } else {
                await reward.cancelAward();
            }
            sendPoint(score, r, timeEnd);
        })

        //FLOW GAME LIXI + FLYING_GIFT

        eventBus.on('needToConfirm', function () {
            console.log('show popup confirm');
            sound.stopEffect('random_audio');
            sound.playEffect('open_audio');
            // if (clicked) return;
            // clicked = true;
            setTimeout(function () {
                html.getModalConfirm(Options, SETTINGS)
            }, 200)
        });

        eventBus.on('cardWaiting', function () {
            console.log('on cardWaiting');
            clicked = true;
            start();
        })

        eventBus.on('startRandom', function () {
            sound && sound.playEffect("random_audio");
        })

        eventBus.on('endRandom', function () {
            sound.stopEffect("random_audio");
        })

        eventBus.on('modal-after-show', function () {
            clicked = false;
        })
        eventBus.on("wheel-stop", async function () {
            console.log('wheel-stop');
            var r = reward.currentReward;

            if (Wheel.game_type == 'matching_items') {
                await reward.award();
            }
            console.log('rewardrewardreward', reward)
            if (r.code || r.sku == "BADLUCK") {
                reward.updateTurnCount();
                sound.stopEffect("rolling_audio");
                sound && sound.playEffect("award_audio");
                if (Wheel.game_type == 'crane_game') {
                    console.log('gameee reset', game)
                    game.resetGame();
                }
                if (Wheel.game_type == 'matching_items') {
                    game.resetGame();
                }
                setTimeout(() => {
                    isSpinning = false
                }, 1000);
                return reward.congratulate(r.sku !== "BADLUCK", Options.is_popup);
            }
        });


        const LOGIN_METHOD_NO_AUTO_FILL = ['no_auth', 'password', 'play_code'];
        eventBus.on('login-done', function () {
            const login_method = Wheel.login_method;
            const userInfo = client.getUserInfo();
            console.log('userInfo', userInfo);
            $('.text-number-turns').css('opacity', '1');

            const shouldAutoFill = !LOGIN_METHOD_NO_AUTO_FILL.includes(login_method);
            if (Wheel.game_type == 'flipcard' || Wheel.game_type == 'matching' || Wheel.game_type == 'merge_game') {
                reward.updateTurnCount = () => {
                    const turn = reward.getRemainTurnCount();
                    game.theGame.updateTurn(turn);
                }
            }
            if (auth.loginBeforeInfoForm(Wheel)) {
                if (shouldAutoFill) {
                    console.log('formAutoFill', {
                        userInfo
                    })
                    helper.formAutoFill(userInfo);
                }
                if (!auth.isUserEnoughData(userInfo)) {
                    console.log('show modal woay userinfo');
                    return html.pushModal('modal-woay-userinfo', 'in login-doneeeeeeeeeeeeeeeeeeeeee');
                }
                client.form.handleInfoForm('modal-woay-userinfo', async (error, formData) => {
                    if (error) return;
                    console.log('update success updateInfoAfterLogin', formData);
                    updateInfoAfterLogin(formData);
                })
            }
            if (Wheel.game_type == 'lixi' || Wheel.game_type == 'flying_gift') {
                if (reward.isOutOfTurn() && !Options.Wheel.is_test_mode) return;
                start();
            }
        })

        // FLOW GAME QUIZ

        eventBus.on('endQuizGame', async function (totalScore, rightAnswer, totalAnswer, count_question_time, question_per_day) {
            console.log('count_question_time', count_question_time);
            const r = reward.currentReward;
            if (quickScheme == 'quick') {
                pointReward = Wheel.rules.POINT_REWARD || Wheel.design.POINT_REWARD;
                console.log('scheme là quick');
                if (!pointReward) {
                    console.log('set mặc định pointReward');
                    pointReward = 0;
                }
                console.log('pointReward', pointReward);
                if (totalScore >= pointReward) {
                    console.log('case trúng quà');
                    isEnoughPointReward = true;
                    await reward.award();
                } else if (totalScore < pointReward) {
                    await reward.cancelAward();
                }
            } else {
                await reward.cancelAward();
            }
            sendPoint(totalScore, r, count_question_time, question_per_day, rightAnswer, totalAnswer);
        })
    }

    function showPhoneDemo(phone) {
        const hideCounter = Wheel.rules.counterPhone;
        return phone.substring(0, phone.length - hideCounter) + '*'.repeat(hideCounter);
    }

    function showEmailDemo(email) {
        if (email === 'null' || !email) return
        const AsignIndex = email.indexOf('@');
        let headString = email.substring(0, AsignIndex);
        let tailString = email.substring(AsignIndex);
        const hideCounter = Wheel.rules.counterEmail;
        return headString.substring(0, headString.length - hideCounter) + '*'.repeat(hideCounter) + tailString;
    }

    $(document).on('click', '.btn-section-game', function () {
        var LIST_GAME_MUST_JUMP_TO_PLAY = ['slot_machine'];
        if (!LIST_GAME_MUST_JUMP_TO_PLAY.includes(Wheel.game_type)) {
            start();
        } else {
            jumpToView('section-game');
        }
    })

    $(document).on('click', '#btn-next-prize', function () {
        console.log('next');
        game.theWheel.next_prize_image();
    })

    $(document).on('click', '#btn-prev-prize', function () {
        console.log('prev');
        game.theWheel.prev_prize_image();
    })

    $(document).on('click', '#spinner', function () {
        if (!list_user.length) return alert("Bạn chưa thiết lập danh sách");
        const candidates = list_user.filter((x) => !x.custom_9);
        // console.log('candidates', candidates, list_user);
        if (!candidates.length) {
            return alert('Tất cả người chơi đều có giải');
        }

        let rand = Math.floor(Math.random() * candidates.length);
        var number = candidates[rand].player.provider_uid;

        return game.theWheel.spin(number);
    });


    $(document).on('click', '#confirm', function () {
        var provider_uid = game.theWheel.confirmPrize();
        var user = list_user.find(item => item.player.provider_uid === provider_uid);
        var prize = $('.name-prize').attr('data-prize');
        if (user) {
            user.custom_9 = prize;
        }
        console.log('postdata', user, list_user);
        var postData = {
            name: user.name,
            phone: user.phone,
            email: user.email,
            provider_uid: provider_uid,
            seed: "GIAINHAT"
        }
        api.confirmPirze(postData);

    });
    $(document).on('click', '#btn-show-result', async function () {
        var rewards = await api.getRewards();
        console.log('rewards', rewards);
        var html_list = '';
        rewards.forEach(e => {
            html_list += `
                  <tr>
                    ${Wheel.rules.isShowName ? "<td>" + e.player_game.name + "</td>" : ""}
                    ${Wheel.rules.isShowEmail ? "<td>" + showEmailDemo(e.player_game.email) + "</td>" : ""}
                    ${Wheel.rules.isShowPhone ? "<td>" + showPhoneDemo(e.player_game.phone) + "</td>" : ""}
                    <td>${e.item_seed}</td>
                  </tr>
                  `;
            $("#list-result").html(html_list);
        });
        html.showModal('w-modal-result')
        console.log('Wheel', Wheel);
        // <td>${e.player_game.provider_uid}</td>
    })


    $(document).on('click', '#reseter', function () {
        return game.theWheel.init();
    });

    $(document).on('click', '#w-exit-game', function () {
        html.closeAllModal();
        jumpToView('section-main-screen');
    })

    document.addEventListener("visibilitychange", onVisibilityChanged, false);
    document.addEventListener("mozvisibilitychange", onVisibilityChanged, false);
    document.addEventListener("webkitvisibilitychange", onVisibilityChanged, false);
    document.addEventListener("msvisibilitychange", onVisibilityChanged, false);


    function loadGame(g) {
        game = g;
    }

    function loadEventBus(eb) {
        eventBus = eb;
        handleEvents();
    }

    return {
        start,
        $,
        client,
        verifyLoginDone,
        jumpToView,
        jumpBack,
        local,
        loadGame,
        loadEventBus
    }
}
WoayCore.$ = $
window.WoayCore = WoayCore;